"use strict";

import jQuery from 'jquery';

/**
 * Control zum (de-)aktivieren der Vollbildansicht via Browser-Fullscreen-API.
 *
 * @class
 * @extends gc.gis.control.GCAbstractMapControl
 * @memberof gc.gis.control
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen (siehe {@link gc.gis.control.GCAbstractMapControl})
 */
gc.gis.control.GCMapFullscreen = function(options)
{
    gc.gis.control.GCAbstractMapControl.call(this, options);

    var self = this;

	/**
	 * @private
	 * @type {jQuery}
     */
	this.__element_fullscreen = undefined;

	this._render();

	gc.gis.iface.ui.on( gc.gis.ui.GCUserInterfaceEvent.FULLSCREEN_CHANGED, this, function(evt) {
        self._toggleButton();
    });
};
gc.gis.control.GCMapFullscreen.prototype = Object.create(gc.gis.control.GCAbstractMapControl.prototype);

/**
 * @inheritdoc
 */
gc.gis.control.GCMapFullscreen.prototype.init = function()
{

};

/**
 * Rendert das Control.
 *
 * @return {jQuery} Container-Element
 * @protected
 */
gc.gis.control.GCMapFullscreen.prototype._render = function()
{
	var self = this;

    if( !this._element )
    {
        this._element = jQuery('<div>', {
            'class': 'gc-map-control gc-map-control-fullscreen'
        });

        this.__element_fullscreen = jQuery('<button>', {
            'class': 'gc-map-control-button gc-map-control-button-fullscreen',
            title: 'Vollbildansicht aktivieren',
            html: '<span>Vollbildansicht an/aus</span>',
            click: function (evt) {
                evt.preventDefault();
                try {
                    self._toggleFullscreen();
                }
                catch (err) {
                    gc.gis.iface.log.error(self, err);
                }
                jQuery(this).blur();
            }
        });
        this.__element_fullscreen_icon = jQuery('<span>', {
            'class': 'gc-icon glyphicon glyphicon-fullscreen'
        });
        this.__element_fullscreen.prepend(this.__element_fullscreen_icon);

	    gc.gis.iface.ui.tooltip(this.__element_fullscreen, {
		    placement: 'auto left'
	    });

        this._element.append(this.__element_fullscreen);
    }

	return this._element;
};

gc.gis.control.GCMapFullscreen.prototype._toggleFullscreen = function()
{
    gc.gis.iface.ui.toggleFullscreen();
};

gc.gis.control.GCMapFullscreen.prototype._toggleButton = function()
{
	if (this.__element_fullscreen)
	{
		if (!gc.gis.iface.ui.isFullscreenEnabled())
		{
            this.__element_fullscreen.removeClass('gc-active');
            this.__element_fullscreen.attr('title', 'Vollbildansicht aktivieren');
            this.__element_fullscreen.attr('data-original-title', 'Vollbildansicht aktivieren');
            this.__element_fullscreen_icon.removeClass('glyphicon-resize-small');
            this.__element_fullscreen_icon.addClass('glyphicon-fullscreen');
		}
		else {
            this.__element_fullscreen.addClass('gc-active');
            this.__element_fullscreen.attr('title', 'Vollbildansicht verlassen');
            this.__element_fullscreen.attr('data-original-title', 'Vollbildansicht verlassen');
            this.__element_fullscreen_icon.removeClass('glyphicon-fullscreen');
            this.__element_fullscreen_icon.addClass('glyphicon-resize-small');
		}
	}
};